if (!customElements.get('gpd-video-gallery')) {
  class GPDVideoGallery extends HTMLElement {
    connectedCallback() {
      this.videos = Array.from(this.querySelectorAll('video'));
      this.slides = Array.from(this.querySelectorAll('.gpd-video__slide'));
      this.track = this.querySelector('.gpd-video__track');
      this.current = this.querySelector('[data-gpd-video-current]');
      this.index = 0;
      this.inViewport = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.previousButton = this.querySelector('[data-gpd-video-prev]');
      this.nextButton = this.querySelector('[data-gpd-video-next]');
      this.onPrevious = () => this.setIndex(this.index - 1);
      this.onNext = () => this.setIndex(this.index + 1);
      this.previousButton?.addEventListener('click', this.onPrevious);
      this.nextButton?.addEventListener('click', this.onNext);

      this.videos.forEach((video) => {
        video.addEventListener('play', () => {
          this.videos.forEach((otherVideo) => {
            if (otherVideo !== video) otherVideo.pause();
          });
        });
      });

      this.observer = new IntersectionObserver((entries) => {
        this.inViewport = entries.some((entry) => entry.isIntersecting);
        this.syncPlayback();
      }, { threshold: 0.35 });
      this.observer.observe(this);
      this.setIndex(0);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.previousButton?.removeEventListener('click', this.onPrevious);
      this.nextButton?.removeEventListener('click', this.onNext);
      this.videos?.forEach((video) => video.pause());
    }

    setIndex(nextIndex) {
      if (!this.slides.length) {
        this.syncPlayback();
        return;
      }

      this.index = (nextIndex + this.slides.length) % this.slides.length;
      this.style.setProperty('--gpd-video-index', this.index);
      this.slides.forEach((slide, index) => slide.setAttribute('aria-hidden', String(index !== this.index)));
      if (this.current) this.current.textContent = String(this.index + 1);
      this.syncPlayback();
    }

    syncPlayback() {
      const canAutoplay = this.dataset.autoplay === 'true' && this.inViewport && !this.reducedMotion;
      this.videos.forEach((video, index) => {
        const isActive = this.dataset.layout === 'feature' || index === this.index;
        if (canAutoplay && isActive) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }
  }

  customElements.define('gpd-video-gallery', GPDVideoGallery);
}
